import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 0px 16px 0px;
    border-bottom: 1px solid ${theme.colorsV2.gray30};

    ${theme.mediaQueries.sm} {
      padding: 0px 0px 40px 0px;
    }
  `}
`;

export const AuthorContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
`;

export const HeaderText = styled(Text).attrs({
  as: 'a',
  textStyle: 'sixthLevelHeadline',
})``;

export const WorkDate = styled(Text).attrs({
  as: 'h2',
  color: 'uiBlackMediumEmphasis',
  textStyle: 'bodySmall',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray60};
  `}
`;

export const UserReviewContent = styled(Text).attrs({
  textStyle: 'bodyRegular',
})`
  text-align: justify-left;
`;

export const RecommendationText = styled(Text).attrs({
  textStyle: 'bodySmall',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray80};
    display: flex;
    flex-direction: row;
    text-align: justify-left;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;

    svg {
      width: 16px;
      height: 16px;
    }
  `}
`;

export const Recommended = styled(Text).attrs({ textStyle: 'subtitleSmall' })`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray80};
  `}
`;

export const MoreReviewsContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MoreReviewsCtaContainer = styled.button<{ $isOpen?: boolean }>`
  ${({ $isOpen = false, theme }) => css`
    display: flex;
    align-items: center;
    gap: 6px;

    & svg {
      transition: transform 0.3s ease;
      transform: rotate(${$isOpen ? '180deg' : '0deg'});
    }

    ${theme.mediaQueries.lg} {
      align-self: flex-end;
    }
  `}
`;

export const MoreReviewsCta = styled(Text).attrs({
  as: 'span',
  textStyle: 'subtitleSmall',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray80};
  `}
`;

export const MoreReviews = styled.div<{
  $extraMarginOnTop?: boolean;
  $isVisible?: boolean;
}>`
  ${({ $extraMarginOnTop = false, $isVisible }) => css`
    display: ${$isVisible ? 'flex' : 'none'};
    flex-direction: column;
    gap: 24px;

    ${$extraMarginOnTop
      ? css`
          margin-top: 8px;
        `
      : ''};
  `}
`;
